import { render, staticRenderFns } from "./Detail2.vue?vue&type=template&id=22fdb6ee&scoped=true"
import script from "./Detail2.vue?vue&type=script&lang=js"
export * from "./Detail2.vue?vue&type=script&lang=js"
import style0 from "./Detail2.vue?vue&type=style&index=0&id=22fdb6ee&prod&lang=scss"
import style1 from "./Detail2.vue?vue&type=style&index=1&id=22fdb6ee&prod&lang=scss&scoped=true"
import style2 from "./Detail2.vue?vue&type=style&index=2&id=22fdb6ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fdb6ee",
  null
  
)

export default component.exports